import { Widget } from "@mcleod/components";
import { HomeWidgetProps } from "./HomeWidgetProps";

export class HomeWidget extends Widget {
  private _cellHeight: number;
  private _cellWidth: number;
  cellX: number;
  cellY: number;

  constructor(props?: Partial<HomeWidgetProps>) {
    super({ borderColor: "primary.darker", style: { position: "absolute", overflow: "hidden" }, ...props});
  }

  get cellHeight(): number {
    return this._cellHeight == null ? 1 : this._cellHeight;
  }

  set cellHeight(value: number) {
    this._cellHeight = value;
    if (value > 0 && value <= 8)
      this.height = (value * 12.5) + "%"
  }

  get cellWidth(): number {
    return this._cellWidth == null ? 1 : this._cellWidth;
  }

  set cellWidth(value: number) {
    this._cellWidth = value;
    if (value > 0 && value <= 8)
      this.width = (value * 12.5) + "%"
  }
}
